import {Button} from "@mui/material";


export interface APXColouredButtonProps {
	  variant?: "contained" | "outlined" | "text";
	  defaultDisabled?: boolean;
	  text: string;
	  backgroundColour: string;
	  hoveredColour: string;
	  onClick: () => void;
}


export default function APXColouredButton(
		  {variant = "contained", defaultDisabled = false, text, backgroundColour, hoveredColour, onClick}: APXColouredButtonProps
) {
	  return (
				 <>
						<Button variant={variant}
								  fullWidth
								  disabled={defaultDisabled}
								  sx={{
										 m: 1,
										 backgroundColor: backgroundColour,
										 "&:hover": {
												backgroundColor: hoveredColour
										 }
								  }}
								  onClick={onClick}
						>
							  {text}
						</Button>
				 </>
	  );
}